import React from 'react';

import { H1 } from './headline1-styled-component';

const Headline1 = props => {
  return <H1 {...props}>{props.children}</H1>;
};

export default Headline1;
